namespace Gamification.Gamification {
    export class ProdottiEsperienzePunteggiColumns {
        static columnsKey = 'Gamification.ProdottiEsperienzePunteggi';
    }
}
